module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/madison-d6be717ccb56c514dd6749f6a1db081b.jpg";